<svg viewBox="5 0 25 40">
  <defs>
    <linearGradient id="progress" x1="0" y1="1" x2="0" y2="0">
      <stop id="accomplished" [attr.offset]="progress + '%'" />
      <stop id="pending" [attr.offset]="progress + '%'" />
    </linearGradient>
  </defs>

  <path
    d="M78.365,4.879A17.167,17.167,0,0,0,66.044,0,17.368,17.368,0,0,0,53.663,4.879a15.605,15.605,0,0,0-5.149,11.758,15.665,15.665,0,0,0,4.9,11.563c-.262.375-.531.739-.808,1.076A21.76,21.76,0,0,1,50.5,31.5c-.285.263-.522.466-.684.6s-.234.188-.234.188L46.955,34.3l3.224.744a14.345,14.345,0,0,0,2.979.28h.1a15.5,15.5,0,0,0,8.433-2.46,18.99,18.99,0,0,0,4.353.487,17.146,17.146,0,0,0,12.3-4.9,15.781,15.781,0,0,0,5.112-11.817A15.69,15.69,0,0,0,78.365,4.879M65.993,29.336a12.51,12.51,0,0,1-4.073-.687A11.22,11.22,0,0,1,57.75,31.4a12.918,12.918,0,0,1-3.528.764c.259-.287.524-.6.792-.922s.528-.67.789-1.033a16.433,16.433,0,0,0,2.09-3.832,12.586,12.586,0,1,1,8.1,2.959"
    transform="translate(-46.955)"
    fill="url(#progress)"
  ></path>
</svg>
